import React, { Component } from 'react';
import PropTypes from 'prop-types';
import IconButton from '@material-ui/core/IconButton';
import FileUploadIcon from '@material-ui/icons/CloudUpload';
import _ from 'lodash';
import { getAccountPath } from '../../../utils/firebase';
import { get } from '../../../utils/request';
import ImageLoader from 'react-image-file';

import { uuid } from '../../../utils/helper';
import FirebaseImage from '../FirebaseImage';

import styles from './styles';

// const NO_IMAGE = 'https://assets.staza.io/images/noimage.png';
const NO_IMAGE = '/images/noimage.png';

class ImageUpload extends Component {
  static propTypes = {
    path: PropTypes.string,
    width: PropTypes.number,
    height: PropTypes.number,
    type: PropTypes.string,
    onChange: PropTypes.func.isRequired,
  };

  state = {
    uploadVisible: false,
  };

  // componentWillMount() {
  //   get({
  //     url: '/v1/accounts/7MDeqzEkizVLZX1KgCDw/customers/vXJeknduFtHSeoUg7fet/logo',
  //   }).then((data) => {
  //     console.log('dataaaa', data);
  //
  //     blobToDataURL(data, (url) => {
  //       console.log('url',url);
  //       this.setState({
  //         src: url,
  //       });
  //     })
  //   })
  // }

  handleUpload = () => {
    this.fileUpload.click();
  };

  handleOpacityOn = () => {
    document.getElementById('image').style.opacity = 0.2;
  };

  handleOpacityOff = () => {
    document.getElementById('image').style.opacity = 1;
  };

  handleImageChange = (e) => {
    e.preventDefault();

    const reader = new FileReader();
    const file = e.target.files[0];
    if (!file) {
      return null;
    }

    console.log('file', file);

    // var reader = new FileReader();
    // reader.onload = function (e) {
    //   this.img.src = e.target.result;
    // };
    // reader.readAsDataURL(file);

    console.log('img', this.img);
    // this.img.src = file;
    // $('#blah')
    //   .attr('src', e.target.result)

    const fileExtension = file.name.split('.').pop();
    const filename = `${uuid()}.${fileExtension}`;
    console.log('filename ============>', filename);
    //TODO review
    // if (this.props.type === 'employee') {
    //   FireBaseTools.uploadEmployeeImage(filename, file);
    // } else if (this.props.type === 'customer') {
    //   FireBaseTools.uploadCustomerImage(filename, file);
    // }
    reader.onloadend = (e) => {
      this.setState({
        file,
        data: reader.result,
        // imagePreviewUrl: reader.result,
      });
      // console.log('result', reader.result);
      // this.img.src = reader.result;

      this.props.onChange(_.assign(file, { data: reader.result }))
      // document.getElementById('image').style.opacity = 1;
      // this.props.onUpload(filename, file);
    };

    reader.readAsDataURL(file);
  };

  render() {
    const { readOnly, src, alt, path } = this.props;

    if (readOnly) {
      return (<img alt={alt || 'Staza'} src={src || NO_IMAGE}/>);
    }

    // let src = this.state.imagePreviewUrl ? this.state.imagePreviewUrl : this.props.src;
    // if (!src) {
    //   src = NO_IMAGE;
    // }

    return (
      <div
        style={styles.container}
        onMouseEnter={() => this.setState({ uploadVisible: true })}
        onMouseLeave={() => this.setState({ uploadVisible: false })}
        onClick={() => this.handleUpload()}
      >

        {this.state.uploadVisible ? <IconButton
          style={styles.upload}
          onMouseEnter={this.handleOpacityOn}
          onMouseLeave={this.handleOpacityOff}
        >
          <FileUploadIcon/>
        </IconButton> : null}

        { this.state.data ? (<div style={styles.imageContainerStyle}>
        <img
        alt={alt || 'Staza'}
        id="image"
        src={this.state.data}
        style={styles.image}
        ref={(img) => this.img = img}/>
        </div>) : <FirebaseImage id="image" path={path} notFound={<img src={NO_IMAGE} alt="not found"/>}/> }

        <input
          type="file"
          ref={(fileUpload) => this.fileUpload = fileUpload}
          onChange={this.handleImageChange}
          style={styles.fileInput}
        />
      </div>
    );
  }
}

export default ImageUpload;



// WEBPACK FOOTER //
// ./src/components/Common/ImageUpload/index.js